import React, { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import draftToHtml from 'draftjs-to-html'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Generic from './Generic'
import Window from 'components/dialog/Window'
import Welcome from 'components/book/WelcomePage'
import Image from 'components/widgets/Image'

import {
  getUrl,
} from 'utils/storage'

import bookingformSelectors from 'store/selectors/bookingform'

const SCHEMA = [{
  id: 'meta.homepage_title',
  title: 'Title',
  helperText: 'The title of the welcome page',
}, {
  id: 'meta.homepage_intro',
  title: 'Intro',
  helperText: 'Introduce your event',
  component: 'markdown',
  height: 300,
}, [
  {
    id: 'meta.homepage_images',
    title: 'Images',
    helperText: 'Add some images to the gallery',
    component: 'list',
    list_window_size: 'md',
    list_schema: [{
      id: 'file',
      title: 'File',
      helperText: 'Upload a file',
      component: 'image',
      path: 'email_attachments',
      validate: {
        type: 'object',
        methods: [
          ['required', 'The file is required'],
        ]
      }
    }],
    list_table: [{
      name: 'file',
      title: 'File',
    }],
    list_table_map: (data) => {
      return Object.assign({}, data, {
        file: (
          <Typography variant="caption">
            <Image
              data={ data.file }
              className="preview_image"
            /><br />
            <a href={ getUrl(data.file.filepath) } target="_blank">{ data.file.filename }</a>
          </Typography>
        ),
      })
    }
  },
  {
    id: 'meta.homepage_embed_widget',
    title: 'Upcoming Dates',
    helperText: 'Display a list of upcoming events with links to book',
    component: 'embedWidget',
  }
], {
  id: 'meta.homepage_footer',
  title: 'Footer',
  helperText: 'A space for some general content about the booking',
  component: 'markdown',
  height: 300,
  innerHeight: 200,
}]


const useStyles = makeStyles(theme => ({
  actionButton: {
    marginLeft: theme.spacing(1),
  },
}))

const BookingFormWelcomePage = ({

}) => {

  const classes = useStyles()
  const [ preview, setPreview ] = useState(null)

  const data = useSelector(bookingformSelectors.editBookingForm)

  const processPayload = useCallback((payload) => {
    const homepage_intro_html = draftToHtml(payload.meta.homepage_intro)
    const homepage_footer_html = draftToHtml(payload.meta.homepage_footer)
    const newPayload = Object.assign({}, payload, {
      meta: Object.assign({}, payload.meta, {
        homepage_intro_html,
        homepage_footer_html,
      })
    })
    return newPayload
  }, [])

  const getButtons = useCallback(({
    values,
  }) => {
    const useMeta = Object.assign({}, data.meta, values.meta)
    const useData = Object.assign({}, data, {
      meta: useMeta,
    })
    return (
      <>
        <Button
          className={ classes.actionButton }
          variant="contained"
          onClick={ () => setPreview(useData) }
        >
          Preview
        </Button>
      </>
    )
  }, [
    data,
  ])
  return (
    <>
      <Generic
        title="Welcome Page"
        schema={ SCHEMA }
        getButtons={ getButtons }
        processPayload={ processPayload }
      />
      {
        preview && (
          <Window
            open
            size="lg"
            fullHeight
            withCancel
            onCancel={ () => setPreview(null) }
          >
            <Welcome
              data={ preview }
              onProceed={ () => setPreview(null) }
            />
          </Window>
        )
      }
    </>
  )
}

export default BookingFormWelcomePage